import { LuChevronDown } from 'react-icons/lu';

import { withStroke } from '../../utils/withStroke';

const ChevronDownIcon = withStroke(LuChevronDown);

export { ChevronDownIcon };
